module.exports = __webpack_public_path__ + "static/badgeimg-7837e5b9ffc99bdaed5eac0869670ef0.png";